module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"products":{"comparison_list":{"empty":"Ihre Vergleichsliste ist leer. Fügen Sie mit Hilfe der Checkbox bis zu 10 Produkte zur Vergleichsliste hinzu.","start_comparison":"Fondsvergleich starten","toggle":"Vergleichsliste (%{count}/%{max})"}}}}}}')
  delete Component.options._Ctor
}
